import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import ParLevelService from '../services/ParLevelService';
import { isEmpty } from 'lodash';

const initialState = {
    data: [],
    datas: [],
    formError: [],
    pagination: {
        page: 0,
        perPage: '50',
        total: 0,
        lastPage: 0,
    },
    error: null,
    status: '',
    loading: false,
    submitLoading: false,
};

export const fetchParLevels = createAsyncThunk(
    'parLevel/list',
    async ({ per_page, page, keyword, shop_id }) => {
        try {
            const resp = await ParLevelService.List({ per_page, page, keyword, shop_id });
            return resp;
        } catch (e) {
            return e.response;
        }
    }
);

export const bulkUpdateParLevels = createAsyncThunk(
    'parLevel/bulkUpdate',
    async ({ shop_id, items }, { dispatch, rejectWithValue }) => {
        try {
            const resp = await ParLevelService.BulkUpdate({ shop_id, items });
            if (resp.status === 200) {
                toast.success('PAR Levels updated successfully');
                return resp;
            }
            return rejectWithValue(resp.data);
        } catch (e) {
            toast.error(e.response?.data?.message || 'Failed to update PAR Levels');
            return rejectWithValue(e.response?.data);
        }
    }
);

const parLevelSlice = createSlice({
    name: 'parLevel',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchParLevels.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchParLevels.fulfilled, (state, action) => {
                if (action.payload?.status === 200) {
                    state.datas = action.payload?.data?.data?.settings || [];
                    state.pagination = action.payload?.data?.data?.pagination || initialState.pagination;
                } else {
                    state.error = action.payload?.data?.message || 'Failed to load settings';
                }
                state.loading = false;
            })
            .addCase(fetchParLevels.rejected, (state, action) => {
                state.error = action.payload?.data;
                state.loading = false;
            })
            .addCase(bulkUpdateParLevels.pending, (state) => {
                state.submitLoading = true;
            })
            .addCase(bulkUpdateParLevels.fulfilled, (state) => {
                state.submitLoading = false;
            })
            .addCase(bulkUpdateParLevels.rejected, (state) => {
                state.submitLoading = false;
            });
    },
});

export const parLevelSelector = (state) => state.parLevel;
export default parLevelSlice.reducer;
